<template>
  <v-container
    class="ma-0 pa-0 blue"
    fluid
    :class="{'fullscreen': fullscreen}"
    v-if="activeModule"
  >
    <v-layout>
      <v-flex xs12>
        <v-system-bar
          class="no-select sticky-toolbar"
          window
          dark
          color="primary darken-2"
        >
          <v-menu
            offset-y
            min-width="200"
            left
            v-model="moduleSelectMenu"
          >
            <span
              slot="activator"
              color="primary"
              dark
            >
              {{ activeModule.title }} <v-icon>{{ moduleSelectMenu ? 'arrow_drop_up' : 'arrow_drop_down' }}</v-icon>
            </span>
            <v-list>
              <v-list-tile
                v-for="(item, index) in eventModules"
                :key="index"
                @click="moduleName = item.name"
              >
                <v-list-tile-title>{{ item.title }}</v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-menu>
          <v-spacer></v-spacer>
          <v-icon @click="toggleFullscreen">{{ fullscreen ? 'fullscreen_exit' : 'fullscreen' }}</v-icon>
        </v-system-bar>

        <chat-module
          v-if="activeModule.name === 'CHAT'"
          class="module-height-fix"
          :style="{ height: moduleHeight + 'px' }"
          :event-id="this.$route.params.id"
          :key="this.$route.params.id"
        />
        <map-module
          v-if="activeModule.name === 'MAP'"
          class="module-height-fix"
          :style="{ height: moduleHeight + 'px' }"
        />
        <contacts-module
          v-if="activeModule.name === 'CONTACTS'"
          class="module-height-fix"
          :style="{ height: moduleHeight + 'px' }"
          :event-id="this.$route.params.id"
          :key="this.$route.params.id"
        />
        <partners-module
          v-if="activeModule.name === 'PARTNERS'"
          class="module-height-fix"
          :style="{ height: moduleHeight + 'px' }"
          :event-id="this.$route.params.id"
          :key="this.$route.params.id"
        />
        <translators-module
          v-if="activeModule.name === 'TRANSLATORS'"
          class="module-height-fix"
          :style="{ height: moduleHeight + 'px' }"
          :event-id="this.$route.params.id"
          :key="this.$route.params.id"
        />
        <customers-module
          v-if="activeModule.name === 'CUSTOMERS'"
          class="module-height-fix"
          :style="{ height: moduleHeight + 'px' }"
          :event-id="this.$route.params.id"
          :key="this.$route.params.id"
        />
        <event-details-module
          v-if="activeModule.name === 'EVENT_DETAILS'"
          class="module-height-fix"
          :style="{ height: moduleHeight + 'px' }"
          :event-id="this.$route.params.id"
          :key="this.$route.params.id"
        />

      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import ChatModule from "../chat/Chat";
import MapModule from "./modules/Map";
import ContactsModule from "./modules/Contacts";
import PartnersModule from "./modules/Partners";
import TranslatorsModule from "./modules/Translators";
import CustomersModule from "./modules/Customers";
import EventDetailsModule from "./modules/EventDetails";

export default {
  data() {
    return {
      fullscreen: false,
      moduleSelectMenu: false,
      moduleName: "",
      moduleHeight: "0"
    };
  },

  computed: {
    eventModules() {
      return this.$store.getters["eventModules"];
    },
    activeModule() {
      return this.eventModules.find(item => {
        return item.name === this.moduleName;
      });
    },
    eventPageLayoutSizes() {
      return this.$store.getters["events/eventPageLayoutSizes"];
    },
    factor() {
      switch (this.position) {
        case "TOP_LEFT":
          return this.eventPageLayoutSizes.topLeft / 100;
        case "TOP_RIGHT":
          return this.eventPageLayoutSizes.topRight / 100;
        case "BOTTOM_LEFT":
          return (100 - this.eventPageLayoutSizes.topLeft) / 100;
        case "BOTTOM_RIGHT":
          return (100 - this.eventPageLayoutSizes.topRight) / 100;
        default:
          return 1;
      }
    }
  },

  methods: {
    toggleFullscreen() {
      this.fullscreen = !this.fullscreen;
      this.handleResize();
    },
    handleResize(data) {
      this.$bus.$emit("map-invalidate-size");
      let windowHeight = window.innerHeight;
      let mainToolbarHeight = document.getElementById("main-toolbar")
        .clientHeight;
      let halfGutterHeight = 0;

      let factor = this.factor;
      if (factor !== 1) {
        halfGutterHeight = 5;
      }

      if (this.fullscreen) {
        mainToolbarHeight = 0;
        halfGutterHeight = 0;
        factor = 1;
      }

      this.moduleHeight =
        (windowHeight - mainToolbarHeight) * factor - halfGutterHeight - 32;
    }
  },

  props: ["initialModule", "split", "position"],

  components: {
    ChatModule,
    MapModule,
    ContactsModule,
    PartnersModule,
    TranslatorsModule,
    CustomersModule,
    EventDetailsModule
  },

  mounted() {
    this.moduleName = this.initialModule;
    window.addEventListener("resize", this.handleResize);
    setTimeout(() => {
      this.handleResize();
    }, 10);

    let self = this;
    this.$bus.$on("event-module-resized", () => {
      setTimeout(() => {
        self.handleResize();
      }, 10);
    });
  },

  beforeDestroy: function() {
    window.removeEventListener("resize", this.handleResize);
  },

  watch: {
    fullscreen: function(val) {
      this.handleResize();
    },
    activeModule: function(val) {
      setTimeout(() => {
        this.handleResize();
      }, 10);
    },
    eventPageLayoutSizes: {
      handler: function(val) {
        this.handleResize();
        this.$bus.$emit("map-invalidate-size");
      },
      deep: true
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.fullscreen .module-height-fix {
  height: calc(100% - 32px);
  overflow: auto;
}

.module-height-fix {
  /* height: calc(100% - 32px); */
  height: 200px;
  overflow-y: auto;
}

.module {
  /* max-height: calc(50% - 32px); */
  overflow: hidden;
}

.no-select {
  user-select: none;
}

.sticky-toolbar {
  width: 100%;
  position: sticky;
  top: 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/events/ModuleContainer.vue